import React, { useEffect } from 'react';
import { useOwnerCalendar } from '../../../context/OwnerCalendarContext';
import '../../../styles/OwnerCalendarControls.css';

const OwnerCalendarControls = ({
                                   trainers = [],
                                   ownerDogs = [],
                                   services = [],
                                   onMultipleBookingClick
                               }) => {
    const {
        selectedTrainer,
        selectedDogId,
        selectedServiceId,
        selectedSlots,
        bookingMode,
        schoolSettings,
        selectTrainer,
        selectDog,
        selectService,
    } = useOwnerCalendar();

    // Auto-select single dog
    useEffect(() => {
        if (ownerDogs.length === 1 && !selectedDogId) {
            selectDog(ownerDogs[0].id);
        }
    }, [ownerDogs, selectedDogId, selectDog]);

    // Auto-select single service
    useEffect(() => {
        if (services.length === 1 && !selectedServiceId) {
            selectService(services[0].id);
        }
    }, [services, selectedServiceId, selectService]);

    const handleTrainerChange = (e) => {
        const trainerId = e.target.value;
        const trainer = trainers.find(t => t.id === trainerId) || null;
        selectTrainer(trainer);
    };

    const handleDogChange = (e) => {
        selectDog(e.target.value);
    };

    const handleServiceChange = (e) => {
        selectService(e.target.value);
    };

    // Check if all selections are made
    const allSelected = selectedTrainer && selectedDogId && selectedServiceId;
    const hasSelectedSlots = selectedSlots.length > 0;

    return (
        <div className="owner-calendar-controls">
            <div className="owner-controls-row">
                {/* Trainer Picker */}
                <div className="owner-control-item">
                    <select
                        id="trainer-select"
                        value={selectedTrainer?.id || ''}
                        onChange={handleTrainerChange}
                        className={`owner-dropdown ${selectedTrainer ? 'has-value' : ''}`}
                    >
                        <option value="">Wybierz trenera</option>
                        {trainers.map((trainer) => (
                            <option key={trainer.id} value={trainer.id}>
                                {trainer.firstName} {trainer.lastName}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Dog Selector */}
                <div className="owner-control-item">
                    {ownerDogs.length > 1 ? (
                        <select
                            id="dog-select"
                            value={selectedDogId || ""}
                            onChange={handleDogChange}
                            className={`owner-dropdown ${selectedDogId ? 'has-value' : ''}`}
                        >
                            <option value="">Wybierz pupila</option>
                            {ownerDogs.map((dog) => (
                                <option key={dog.id} value={dog.id}>
                                    {dog.name}
                                </option>
                            ))}
                        </select>
                    ) : ownerDogs.length === 1 ? (
                        <div className="owner-selected-value">{ownerDogs[0].name}</div>
                    ) : (
                        <div className="owner-no-value">Wybierz pupila</div>
                    )}
                </div>

                {/* Service Picker */}
                <div className="owner-control-item">
                    {services.length > 1 ? (
                        <select
                            id="service-select"
                            value={selectedServiceId || ""}
                            onChange={handleServiceChange}
                            className={`owner-dropdown ${selectedServiceId ? 'has-value' : ''}`}
                        >
                            <option value="">Wybierz trening</option>
                            {services.map((service) => (
                                <option key={service.id} value={service.id}>
                                    {service.serviceName}
                                </option>
                            ))}
                        </select>
                    ) : services.length === 1 ? (
                        <div className="owner-selected-value">{services[0].serviceName}</div>
                    ) : (
                        <div className="owner-no-value">Wybierz trening</div>
                    )}
                </div>

                {/* Booking Button - Always visible */}
                <div className="owner-control-item owner-control-button">
                    <button
                        className={`owner-book-btn ${allSelected && hasSelectedSlots ? 'active' : ''}`}
                        onClick={onMultipleBookingClick}
                        disabled={!allSelected || !hasSelectedSlots}
                    >
                        Zarezerwuj wybrane daty
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OwnerCalendarControls;